<template>
  <v-text-field
    id="password"
    :label="label"
    name="password"
    prepend-icon="$lock"
    :autofocus="autofocus"
    :disabled="disabled"
    :required="required"
    :append-icon="icon"
    :type="visible ? 'text' : 'password'"
    :value="value"
    @input="$emit('input', $event)"
    @click:append="visible = !visible"
  />
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'

export default {
  name: 'PasswordInput',
  data: () => ({
    visible: false
  }),
  props: {
    value: String,
    autofocus: Boolean,
    required: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      default: 'Password'
    }
  },
  computed: {
    icon () {
      return this.visible ? mdiEyeOff : mdiEye
    }
  }
}
</script>

<style scoped>
.is-focused > * {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
